import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { pathOr } from "ramda";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { Input } from "antd";

import { setPopup } from "../../actions/popupAction";
import { checkUserExist, LoginSagaAction } from "../../sagas/saga-actions";
import CustomButton from "../../components/customButton";
import LoadingSpinner from "../../components/loadingSpinner";
import CustomNotification from "../notification";
import UserService from "../../service/UserService";

import LoginLeftSection from "../loginLeftSection";

const userservice = new UserService();

const SetPassword = (props) => {
  const history = useHistory();

  const { customPopupMessage, messageType, message } = props.popupReducer;

  const [state, setState] = useState({
    checkApiCall: null,
    confirmClick: false,
    isUrlExpired: false,
  });

  const initialValuesChangePassword = {
    password: "",
    confirmPassword: "",
  };

  const changePasswordSchema = Yup.object().shape({
    password: Yup.string()
      .matches(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,20}$/,
        "Must Contain 8 to 20 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
      )
      .required(),
    confirmPassword: Yup.string().required("Confirm Password is required"),
  });

  const checkUrlExpiry = async () => {
    try {
      await userservice.checkUrlExpiry(props.location.search.replace("?", ""));

      setState((st) => ({
        ...st,
        checkApiCall: true,
      }));
    } catch {
      setState((st) => ({
        ...st,
        checkApiCall: false,
        isUrlExpired: true,
      }));
    }
  };

  useEffect(() => {
    checkUrlExpiry();
  }, []);

  const handleKeyDown = (e) => {
    e.keyCode === 13 && state.button && onSubmit();
  };

  const onSubmit = async (values) => {
    try {
      const { data } = await userservice.setNewPassword(
        props.location.search.replace("?", ""),
        values
      );
      // on successful password reset
      if (data.success) {
        setState((st) => ({
          ...st,
          submitpassword: true,
          confirmClick: true,
        }));

        props.setPopup({
          customPopupMessage: true,
          message: "Your password has been changed successfully",
          messageType: "success",
        });
      }

      // if old password is provided
      else {
        props.setPopup({
          customPopupMessage: true,
          message: pathOr("Something went wrong", ["message"], data),
          messageType: "error",
        });
      }
    } catch (err) {
      props.setPopup({
        customPopupMessage: true,
        message: pathOr(
          "Something went wrong",
          ["response", "data", "message"],
          err
        ),
        messageType: "error",
      });
    }
  };

  if (state.checkApiCall === null) {
    return <LoadingSpinner />;
  }

  return (
    <div
      data-testid="set-password-page-wrapper"
      className="login-page-wrapper"
    >
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}

      <main className="login-page-main">
        <LoginLeftSection />

        {state.checkApiCall ? (
          state.submitpassword ? (
            <section className="form-wrapper">
              <h2 className="form-heading">Thank You!</h2>
              <p className="form-caption">Your password has been reset.</p>
              <section className="re-login-field">
                <p className="url-expired">Please Re-login</p>

                <CustomButton
                  htmlType="submit"
                  type="primary"
                  title="Login"
                  onClick={() => history.push("/")}
                />
              </section>
            </section>
          ) : (
            <section className="form-wrapper">
              <h2 className="form-heading">Change Password?</h2>
              <p className="form-caption">Please reset your password</p>
              <Formik
                enableReinitialize
                initialValues={initialValuesChangePassword}
                validationSchema={changePasswordSchema}
                onSubmit={(values) => {
                  onSubmit(values.password);
                }}
              >
                {({
                  touched,
                  dirty,
                  errors,
                  isValid,
                  values,
                  handleBlur,
                  handleChange,
                }) => (
                  <Form className="login-form">
                    <section className="custom-input-group password-field change-password">
                      <Input.Password
                        name="password"
                        className={`custom-form-password ${touched.password &&
                          errors.password &&
                          "error-field"}`}
                        autoComplete="off"
                        placeholder="Set new password"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyDown}
                      />

                      {touched.password && errors.password ? (
                        <div
                          className="error-label"
                          style={{
                            position: "initial",
                            marginBottom: "-16px",
                          }}
                        >
                          {errors.password}
                        </div>
                      ) : null}
                    </section>

                    <section className="custom-input-group password-field change-password">
                      <Input.Password
                        name="confirmPassword"
                        className={`custom-form-password ${touched.confirmPassword &&
                          errors.confirmPassword &&
                          "error-field"}`}
                        autoComplete="off"
                        placeholder="Confirm new password"
                        value={values.confirmPassword}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyDown}
                      />

                      {touched.confirmPassword && errors.confirmPassword ? (
                        <div className="error-label">
                          {errors.confirmPassword}
                        </div>
                      ) : null}
                    </section>

                    <CustomButton
                      htmlType="submit"
                      type="primary"
                      title="Confirm"
                      disabled={
                        values.password !== values.confirmPassword ||
                        !(isValid && dirty)
                      }
                      className={
                        values.password !== values.confirmPassword ||
                        !(isValid && dirty)
                          ? "disable-button"
                          : ""
                      }
                    />

                    {values.password &&
                      values.confirmPassword !== "" &&
                      values.confirmPassword !== values.password && (
                        <section className="password-notifier">
                          <p>Password fields must match</p>
                        </section>
                      )}
                  </Form>
                )}
              </Formik>

              <span className="errorspan">{state.errconfirmnewpassword}</span>

              {state.errorboxshowsetpasswordconfirm === true ? (
                <ul>
                  <li id="match" class="invalid">
                    Password fields must match
                  </li>
                </ul>
              ) : (
                ""
              )}
            </section>
          )
        ) : (
          <section className="form-wrapper">
            <h2 className="form-heading">Change Password?</h2>
            <p className="form-caption">Please reset your password</p>
            <h3 className="url-expired">
              {state.isUrlExpired ? "URL Expired" : ""}
            </h3>
          </section>
        )}
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    popupReducer: state.popupReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    LoginSagaAction: (data) => {
      dispatch(LoginSagaAction(data));
    },
    checkUserExist: (data) => dispatch(checkUserExist(data)),
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SetPassword)
);
